const namedKeys = {
    desktop: '@media (min-width: 1024px)',
    tablet: '@media (min-width: 768px)',
};

export default namedKeys;
